import loadable from '@loadable/component';

export const LazyCreateWedding = loadable(() => import(/* webpackChunkName: "content/createwedding" */ '.'));
